export default "__VITE_ASSET__dA4lln1u__"